import React from 'react';
import {SearchableList} from '../../../../../../components/SearchableList';
import {useScrollWrapDimensions} from '../../../../../../hooks/customScroll/useScrollWrapDimensions';
import {AutomationChoose} from '../../../../reducer/model';

type Props = {
    data: {label: string; value: string}[];
    onSelect: (item: any) => void;
    componentClasses?: string;
    selectedValue?: string;
    placeholder?: string;
    onFocusChange?: (item: AutomationChoose, index: number) => void;
};

export const BPMStatusesList = (props: Props) => {
    const {data, componentClasses, selectedValue, placeholder, onSelect, onFocusChange} = props;
    const {maxHeight, setWrapRef} = useScrollWrapDimensions();

    return (
        <div className="pui-scrollable-wrap" ref={setWrapRef}>
            <SearchableList
                data={data}
                showSearch={false}
                onItemClick={onSelect}
                componentClasses={componentClasses}
                selectedValue={selectedValue}
                autoHeightMax={maxHeight}
                onFocusChange={onFocusChange}
                placeholder={placeholder}
            />
        </div>
    );
};
